

















































import { PinCodeMixin } from '@/mixins/pinCodeMixin'
import ConfirmDialog from '@/components/elements/ConfirmDialog.vue'
import { PinElementInterface } from '@/config/interfaces'

export default PinCodeMixin.extend({
  name: 'PinEl',

  components: { ConfirmDialog },

  data: () => ({
    showPopup: false
  }),

  computed: {
    hasPopup (): boolean {
      return !!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'confirmDialog')
    }
  },

  methods: {
    validatePin () {
      if (this.buttonEnabled) {
        this.showPopup = true
      }
    }
  },

  props: {
    templateItemData: {
      type: Object as () => PinElementInterface,
      required: true
    }
  }
})
